<div class="center-content">
      <table id="versions-table">
        <thead>
          <tr>
            <th>Version</th>
            <th>Author</th>
            <th>Timestamp</th>
            <th>Summary</th>
            <th class="column-download"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rev of revisions">
            <td>{{rev.version}}<span *ngIf="rev.version == version"> (current)</span></td>
            <td><span class="author">{{rev.author}}</span></td>
            <td><span class="timestamp" matTooltip="{{rev.timestamp|date:'medium'}}">{{rev.timestamp | date:'mediumDate'}}</span></td>
            <td><span matTooltip="{{rev.summary}}" matTooltipClass="pre-line-tooltip">{{firstLine(rev.summary)}}</span></td>
            <td class="column-download" matTooltip="Download the code lists at this revision of the mapping">
              <button *ngIf="userCanDownload" mat-icon-button (click)="openDownloadDialog(rev.version)"><mat-icon>download</mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
</div>